import { useState } from 'react';
import { ContentWrapper } from '@eti/components';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { breakpoints, Heading, Inline, Stack, vars } from '@etg/wings';
import { routes } from '../../../constants/routesAndApisConstants';
import DatesSearchForm from '../containers/DatesSearchFormContainer';
import BackToPreviousPageButton from '../../../common/components/BackToPreviousPageButton';
import type { SearchDateType, TripType } from '../models';
import ResultsGraphqlContainer from '../containers/ResultsGraphqlContainer';
import OriginalTrip from './OriginalTrip';

const wrapperStyles = css`
  background-color: ${vars.colors.pageBackdrop};
  height: 100%;
  padding-top: 16px;

  @media (min-width: ${breakpoints._768}) {
    padding-top: 24px;
  }
`;

const inlineStyles = (newSearchDates: boolean) => css`
  ${!newSearchDates && 'margin-bottom: 32px;'};
`;

interface ChangeTripPageProps {
  trip: TripType;
}

const ChangeTripPage = ({ trip }: ChangeTripPageProps) => {
  const { t } = useTranslation();
  const [newSearchDates, setNewSearchDates] = useState<SearchDateType | null>(null);

  return (
    <div className={wrapperStyles}>
      <ContentWrapper>
        <Stack
          spacing={{
            [breakpoints._0]: 16,
            [breakpoints._360]: 24,
            [breakpoints._768]: 32,
          }}
        >
          <BackToPreviousPageButton
            dataTestId="changeTrip-back-to-order-details-button"
            linkText={t('ChangeTrip.BackToMyTrip.Text')}
            route={routes.ORDER_DETAILS_MANAGE_TRIP}
          />
          <Stack
            spacing={{
              [breakpoints._0]: 16,
              [breakpoints._768]: 24,
            }}
          >
            <Heading level={1}>{t('ChangeTrip.ReviewPrices.Title')}</Heading>
            <Inline
              className={inlineStyles(Boolean(newSearchDates))}
              collapseBelow={breakpoints._768}
              noWrap
              spacing={24}
            >
              <OriginalTrip originalTrip={trip} />
              <DatesSearchForm originalTrip={trip} setNewSearchDates={setNewSearchDates} />
            </Inline>
          </Stack>
          {newSearchDates && (
            <ResultsGraphqlContainer newSearchDates={newSearchDates} originalTrip={trip} />
          )}
        </Stack>
      </ContentWrapper>
    </div>
  );
};

export default ChangeTripPage;
